export const projectSort: SortOptionType = {
  project_name_asc: {
    label: 'Project Name A-Z',
    value: 'project_name_asc',
    sort_by: 'project_title',
    order: 'asc'
  },
  project_name_des: {
    label: 'Project Name Z-A',
    value: 'project_name_des',
    sort_by: 'project_title',
    order: 'desc'
  },
  due_date_latest_first: {
    label: 'Due Date Latest First',
    value: 'due_date_latest_first',
    sort_by: 'client_deadline',
    order: 'desc'
  },
  due_date_earliest_first: {
    label: 'Due Date Earliest First',
    value: 'due_date_earliest_first',
    sort_by: 'client_deadline',
    order: 'asc'
  }
}

export const draftSort: SortOptionType = {
  project_name_asc: {
    label: 'Project Name A-Z',
    value: 'project_name_asc',
    sort_by: 'project_title',
    order: 'asc'
  },
  project_name_des: {
    label: 'Project Name Z-A',
    value: 'project_name_des',
    sort_by: 'project_title',
    order: 'desc'
  }
}

export const assignmentSort: SortOptionType = {
  deadline_asc: {
    label: 'Deadline (Latest First)',
    value: 'deadline_asc',
    sort_by: 'deadline',
    order: 'asc'
  },
  deadline_desc: {
    label: 'Deadline (Latest Last)',
    value: 'deadline_desc',
    sort_by: 'deadline',
    order: 'desc'
  },
  client_word_count_asc: {
    label: 'No. of Words (Low to High)',
    value: 'client_word_count_asc',
    sort_by: 'word_count',
    order: 'asc'
  },
  client_word_count_desc: {
    label: 'No. of Words (High to Low)',
    value: 'client_word_count_desc',
    sort_by: 'word_count',
    order: 'desc'
  }
}

export const clientUserSort: SortOptionType = {
  company_assignments_asc: {
    label: 'No. of Assignments (Low to High)',
    value: 'company_assignments_asc',
    sort_by: 'company_assignments',
    order: 'asc'
  },
  company_assignments_desc: {
    label: 'No. of Assignments (High to Low)',
    value: 'company_assignments_desc',
    sort_by: 'company_assignments',
    order: 'desc'
  },
  company_assignments_pending_asc: {
    label: 'Total Pending Assignment (Low to High)',
    value: 'company_assignments_pending_asc',
    sort_by: 'company_assignments_pending',
    order: 'asc'
  },
  company_assignments_pending_desc: {
    label: 'Total Pending Assignment (High to Low)',
    value: 'company_assignments_pending_desc',
    sort_by: 'company_assignments_pending',
    order: 'desc'
  },
  total_project_amount_asc: {
    label: 'Total Project Value (Low to High)',
    value: 'total_project_amount_asc',
    sort_by: 'total_project_amount',
    order: 'asc'
  },
  total_project_amount_desc: {
    label: 'Total Project Value (High to Low)',
    value: 'total_project_amount_desc',
    sort_by: 'total_project_amount',
    order: 'desc'
  }
}

export const writerUserSort: SortOptionType = {
  word_count_asc: {
    label: 'Word Count (Low to High)',
    value: 'word_count_asc',
    sort_by: 'word_count_per_day',
    order: 'asc'
  },
  word_count_desc: {
    label: 'Word Count (High to Low)',
    value: 'word_count_desc',
    sort_by: 'word_count_per_day',
    order: 'desc'
  },
  currently_allotted_assignments_asc: {
    label: 'Assignments Allotted (Low to High)',
    value: 'currently_allotted_assignments_asc',
    sort_by: 'currently_allotted_assignments',
    order: 'asc'
  },
  currently_allotted_assignments_desc: {
    label: 'Assignments Allotted (High to Low)',
    value: 'currently_allotted_assignments_desc',
    sort_by: 'currently_allotted_assignments',
    order: 'desc'
  },
  total_assignments_submitted_asc: {
    label: 'Assignments Submitted (Low to High)',
    value: 'total_assignments_submitted_asc',
    sort_by: 'total_assignments_submitted',
    order: 'asc'
  },
  total_assignments_submitted_desc: {
    label: 'Assignments Submitted (High to Low)',
    value: 'total_assignments_submitted_desc',
    sort_by: 'total_assignments_submitted',
    order: 'desc'
  },
  total_assignments_approved_asc: {
    label: 'Assignments Approved (Low to High)',
    value: 'total_assignments_approved_asc',
    sort_by: 'total_assignments_approved',
    order: 'asc'
  },
  total_assignments_approved_desc: {
    label: 'Assignments Approved (High to Low)',
    value: 'total_assignments_approved_desc',
    sort_by: 'total_assignments_approved',
    order: 'desc'
  },
  total_assignments_rejected_asc: {
    label: 'Assignments Rejected (Low to High)',
    value: 'total_assignments_rejected_asc',
    sort_by: 'total_assignments_rejected',
    order: 'asc'
  },
  total_assignments_rejected_desc: {
    label: 'Assignments Rejected (High to Low)',
    value: 'total_assignments_rejected_desc',
    sort_by: 'total_assignments_rejected',
    order: 'desc'
  }
}

export const editorUserSort: SortOptionType = {
  pay_scale_asc: {
    label: 'Pay Scale (Low to High)',
    value: 'pay_scale_asc',
    sort_by: 'pay_scale',
    order: 'asc'
  },
  pay_scale_desc: {
    label: 'Pay Scale (High to Low)',
    value: 'pay_scale_desc',
    sort_by: 'pay_scale',
    order: 'desc'
  },
  currently_allotted_assignments_asc: {
    label: 'Assignments Allotted (Low to High)',
    value: 'currently_allotted_assignments_asc',
    sort_by: 'currently_allotted_assignments',
    order: 'asc'
  },
  currently_allotted_assignments_desc: {
    label: 'Assignments Allotted (High to Low)',
    value: 'currently_allotted_assignments_desc',
    sort_by: 'currently_allotted_assignments',
    order: 'desc'
  },
  total_assignments_approved_asc: {
    label: 'Assignments Approved (Low to High)',
    value: 'total_assignments_approved_asc',
    sort_by: 'total_assignments_approved',
    order: 'asc'
  },
  total_assignments_approved_desc: {
    label: 'Assignments Approved (High to Low)',
    value: 'total_assignments_approved_desc',
    sort_by: 'total_assignments_approved',
    order: 'desc'
  },
  total_assignments_rejected_asc: {
    label: 'Assignments Rejected (Low to High)',
    value: 'total_assignments_rejected_asc',
    sort_by: 'total_assignments_rejected',
    order: 'asc'
  },
  total_assignments_rejected_desc: {
    label: 'Assignments Rejected (High to Low)',
    value: 'total_assignments_rejected_desc',
    sort_by: 'total_assignments_rejected',
    order: 'desc'
  },
  total_assignments_submitted_asc: {
    label: 'Assignments Submitted (Low to High)',
    value: 'total_assignments_submitted_asc',
    sort_by: 'total_assignments_submitted',
    order: 'asc'
  },
  total_assignments_submitted_desc: {
    label: 'Assignments Submitted (High to Low)',
    value: 'total_assignments_submitted_desc',
    sort_by: 'total_assignments_submitted',
    order: 'desc'
  }
}

export const designerSort: SortOptionType = {
  currently_allotted_assignments_asc: {
    label: 'Assignments Allotted (Low to High)',
    value: 'currently_allotted_assignments_asc',
    sort_by: 'currently_allotted_assignments',
    order: 'asc'
  },
  currently_allotted_assignments_desc: {
    label: 'Assignments Allotted (High to Low)',
    value: 'currently_allotted_assignments_desc',
    sort_by: 'currently_allotted_assignments',
    order: 'desc'
  },
  total_assignments_submitted_asc: {
    label: 'Assignments Submitted (Low to High)',
    value: 'total_assignments_submitted_asc',
    sort_by: 'total_assignments_submitted',
    order: 'asc'
  },
  total_assignments_submitted_desc: {
    label: 'Assignments Submitted (High to Low)',
    value: 'total_assignments_submitted_desc',
    sort_by: 'total_assignments_submitted',
    order: 'desc'
  },
  total_assignments_approved_asc: {
    label: 'Assignments Approved (Low to High)',
    value: 'total_assignments_approved_asc',
    sort_by: 'total_assignments_approved',
    order: 'asc'
  },
  total_assignments_approved_desc: {
    label: 'Assignments Approved (High to Low)',
    value: 'total_assignments_approved_desc',
    sort_by: 'total_assignments_approved',
    order: 'desc'
  },
  total_assignments_rejected_asc: {
    label: 'Assignments Rejected (Low to High)',
    value: 'total_assignments_rejected_asc',
    sort_by: 'total_assignments_rejected',
    order: 'asc'
  },
  total_assignments_rejected_desc: {
    label: 'Assignments Rejected (High to Low)',
    value: 'total_assignments_rejected_desc',
    sort_by: 'total_assignments_rejected',
    order: 'desc'
  }
}

export const invoiceSort: SortOptionType = {
  due_date_latest_first: {
    label: 'Due Date Latest First',
    value: 'due_date_latest_first',
    sort_by: 'due_date',
    order: 'asc'
  },
  due_date_earliest_first: {
    label: 'Due Date Earliest First',
    value: 'due_date_earliest_first',
    sort_by: 'due_date',
    order: 'desc'
  }
}

export const assignmentGroupSort: SortOptionType = {
  expiring_first: {
    label: 'Expiring First',
    value: 'expiring_first',
    sort_by: 'client_deadline',
    order: 'desc'
  },
  created_at_asc: {
    label: 'Created First',
    value: 'created_at_asc',
    sort_by: 'created_at',
    order: 'asc'
  },
  created_at_des: {
    label: 'Created Last',
    value: 'created_at_des',
    sort_by: 'created_at',
    order: 'desc'
  },
  last_activity_latest_first: {
    label: 'Latest Activity',
    value: 'last_activity_latest_first',
    sort_by: 'last_activity',
    order: 'asc'
  },
  last_activity_oldest_first: {
    label: 'Oldest Activity',
    value: 'last_activity_oldest_first',
    sort_by: 'last_activity',
    order: 'desc'
  }
}
